// extracted by mini-css-extract-plugin
export var numberInputContainer = "_5q-0";
export var startPickingButton = "_5q-1";